import { entity } from "./Connection"

export const AccountSubscriptionPlanFeatureEntity = entity("AccountSubscriptionPlanFeature");
